import React from 'react';

const OpeningHours = () => {
  return (
    <div className="schedules">
      <p className="text-subtitle text-center my-26">Nuestros horarios de atención:</p>
      <div className="item-wrapper">
        <div className="item">
          <span>Lunes a viernes</span>
          <p>8:00 a.m. a 8:00 p.m.</p>
        </div>
        <div className="item">
          <span>Sábados</span>
          <p>9:00 a.m. a 7:00 p.m.</p>
        </div>
        <div className="item">
          <span>Domingos y festivos</span>
          <p>9:00 a.m. a 5:00 p.m.</p>
        </div>
      </div>
    </div>
  );
};

export default OpeningHours;
